<template functional>
  <div class="difficulty">
    <div
      v-if="props.difficulty && props.difficulty === 'informative'"
      class="difficulty__level-zero"
    >
      <img
        src="@/assets/icons/difficulty/informative.png"
        class="difficulty__level-zero-img"
        :alt="
          `Icon representing the ${props.difficulty} difficulty of the content`
        "
      />
    </div>
    <component
      v-if="props.difficulty && props.difficulty === 'novice'"
      :is="injections.components.BeginnerDifficulty"
      class="difficulty__level-one"
    />
    <component
      v-if="props.difficulty && props.difficulty === 'professional'"
      :is="injections.components.IntermediateDifficulty"
      class="difficulty__level-two"
    />
    <components
      v-if="props.difficulty && props.difficulty === 'advanced'"
      :is="injections.components.AdvancedDifficulty"
      class="difficulty__level-three"
    />
    <component
      v-if="props.difficulty && props.difficulty === 'expert'"
      :is="injections.components.ExpertDifficulty"
      class="difficulty__level-four"
    />
    <div
      v-if="props.difficulty && props.difficulty.length"
      class="difficulty__label"
      :class="{ 'difficulty__label--visible': props.alwaysVisible }"
    >
      {{ props.difficulty }}
    </div>
    <div v-else class="difficulty__label">N/A</div>
  </div>
</template>

<script>
import BeginnerDifficulty from '@/assets/icons/difficulty/BeginnerDifficulty.svg'
import IntermediateDifficulty from '@/assets/icons/difficulty/IntermediateDifficulty.svg'
import AdvancedDifficulty from '@/assets/icons/difficulty/AdvancedDifficulty.svg'
import ExpertDifficulty from '@/assets/icons/difficulty/ExpertDifficulty.svg'

export default {
  name: 'Difficulty',
  inject: {
    components: {
      default() {
        return {
          BeginnerDifficulty: {
            ...BeginnerDifficulty,
            name: 'BeginnerDifficulty',
          },
          IntermediateDifficulty: {
            ...IntermediateDifficulty,
            name: 'IntermediateDifficulty',
          },
          AdvancedDifficulty: {
            ...AdvancedDifficulty,
            name: 'AdvancedDifficulty',
          },
          ExpertDifficulty: { ...ExpertDifficulty, name: 'ExpertDifficulty' },
        }
      },
    },
  },
  props: {
    difficulty: {
      type: String,
      required: true,
    },
    alwaysVisible: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.difficulty {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
  &__label {
    display: none;
    color: var(--white);
    text-transform: capitalize;
    font-family: var(--font-bold);
    @include tablet {
      display: block;
    }
    &--visible {
      display: block;
    }
  }
  &__level-one,
  &__level-two,
  &__level-three,
  &__level-four,
  &__level-five {
    width: 20px;
    margin-right: 10px;
  }
  &__level-zero-img {
    width: 20px;
    margin-right: 10px;
  }
  &__level-one {
    fill: var(--difficulty-level-one);
  }
  &__level-two {
    fill: var(--difficulty-level-two);
  }
  &__level-three {
    fill: var(--difficulty-level-three);
  }
  &__level-four {
    fill: var(--difficulty-level-four);
  }
}
</style>
